import "core-js/modules/es.array.push.js";
import { pxToUnit, resolveTheme } from '../cjs/tombacCommons';
export const space = function () {
  for (var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++) {
    sizes[_key] = arguments[_key];
  }
  return _ref => {
    let {
      theme
    } = _ref;
    const {
      baseSpace,
      baseUnit
    } = resolveTheme(theme);
    return sizes.map(size => pxToUnit(size * baseSpace, baseUnit)).join(' ');
  };
};
export const unit = function () {
  for (var _len2 = arguments.length, px = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    px[_key2] = arguments[_key2];
  }
  return _ref2 => {
    let {
      theme
    } = _ref2;
    const {
      baseUnit
    } = resolveTheme(theme);
    const units = [];
    for (const pxArg of px) units.push(pxToUnit(pxArg, baseUnit));
    return units.join(' ');
  };
};
//# sourceMappingURL=spaceTools.js.map